<template>
    <div class="watermark-layer"></div>
</template>

<script>
export default {
    props: {
        text: String
    },
    mounted() {
        if (this.text) {
            this.addWaterMarker(this.text);
        }
    },
    methods: {
        addWaterMarker(str) {
            const can = document.createElement('canvas');
            document.body.appendChild(can);
            can.width = 100;
            can.height = 50;
            can.style.display = 'none';
            const cans = can.getContext('2d');
            cans.rotate(-20 * Math.PI / 180);
            cans.font = '18px Microsoft JhengHei';
            cans.textBaseline = 'Middle';
            cans.fillStyle = 'rgba(180, 180, 180, 0.20)'; // '#e6e6e6'; //
            cans.fillText(str, 0, 40);
            cans.rotate(20 * Math.PI / 180);
            cans.font = '20px Microsoft JhengHei bold';
            cans.fillStyle = 'rgba(180, 180, 180, 0.02)'; // '#e6e6e6'; //
            for (let i = 0; i <= can.height; i += 20) {
                for (let j = 0; j <= can.width; j += 100) {
                    cans.fillText(str, j, i);
                }
            }
            const imgdata = 'url(' + can.toDataURL('image/png') + ')';
            const cssText = `.watermark-layer { background-image: ${imgdata}; }`;
            this.loadStyleString(cssText);
        },
        loadStyleString(cssText) {
            const style = document.createElement('style');
            style.type = 'text/css';
            try {
                style.appendChild(document.createTextNode(cssText));
            } catch (ex) {
                style.styleSheet.cssText = cssText;
            }
            document.getElementsByTagName('head')[0].appendChild(style);
        }
    }
};
</script>

<style lang="less" scoped>
.watermark-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none;
}
</style>




// WEBPACK FOOTER //
// src/views/marketing/components/watermask.vue